<template lang="pug">
  .posts-feed
    .nav.nav-tabs.nav-primary.nav-fill.mb-5.mb-md-7
      a.nav-item.nav-link(:class="{'active': type === 'all'}" @click="changeType('all')") Newest Updates
      a.nav-item.nav-link(:class="{'active': type === 'projects'}" @click="changeType('projects')") Public Projects
      a.nav-item.nav-link(:class="{'active': type === 'posts'}" @click="changeType('posts')") Blog
      a.nav-item.nav-link(:class="{'active': type === 'events'}" @click="changeType('events')") Events
      a.nav-item.nav-link(:class="{'active': type === 'experts'}" @click="changeType('experts')") People


    template(v-if="this[type]")
      .masonry-grid(v-if="this[type].edges" :class="{'load-more-wrap': (((type === 'all') && !$apollo.loading) || ((type !== 'all') && this[type].pageInfo.hasNextPage))}" v-masonry transition-duration="0.3s" item-selector=".item" gutter="60" column-width=".grid-sizer" fit-width="true")
        .grid-sizer

        template(v-if="type === 'events' && upcomingEvents")
          .item.overflow-hidden.event-item.shadow.rounded(
            v-masonry-tile,
            v-for="(item, index) in upcomingEvents.edges",
            :key="item.node.id"
            :class="'item-' + index",
          )
            .text-center.date.d-flex.flex-column.justify-content-center.py-5.border-right-0
              p.h1.font-weight-bold.mb-0 {{ days(item.node.start, item.node.end) }}
              p.font-weight-bolder.text-uppercase.text-md {{ months(item.node.start, item.node.end) }}
            .border-top.pt-2.px-5.pt-4
              h3.h4.font-weight-bolder.mb-3(v-html="item.node.title")
              .excerpt.lead-sm.mb-3(v-html="item.node.excerpt")
              p.text-muted
                span.icon.icon-sm.float-left.ml-n1.mr-1
                  img(svg-inline :src="icon('map-pointer')")
                | {{ item.node.location }}
            a.stretched-link(:href="item.node.link")

        .item.overflow-hidden(
          v-masonry-tile,
          :class="['item-' + index, item.node.postType + '-item', {'shadow rounded': ['expert', 'event', 'project'].includes(item.node.postType)}, {'past-event': item.node.postType === 'event'}]",
          v-for="(item, index) in this[type].edges",
          :key="item.node.id"
        )
          template(v-if="item.node.postType === 'post'")
            img.rounded(v-if="!index ? item.node.largeImage : item.node.mediumImage" :src="!index ? item.node.largeImage.sourceUrl : item.node.mediumImage.sourceUrl")
            p.text-sm.text-uppercase.text-muted.font-weight-bold.mt-4.mb-1 {{ category(item.node.categories) }}
            h3.h4.font-weight-bolder(v-html="item.node.title")
            .excerpt(v-html="item.node.excerpt")
            p.text-md.text-muted.mt-3.mb-0
              span(v-if="postAuthor(item)") by
              span.font-italic
                span(v-if="postAuthor(item)")  {{ postAuthor(item) }},
                span  {{ item.node.dateGmt | moment("MMM Do YYYY") }}
            a.stretched-link(:href="item.node.link")

          template(v-if="item.node.postType === 'social'")
            .fb-post(
              v-if="item.node.type === 'fb'"
              :data-href="item.node.url"
              data-width="auto"
            )
            .twitter-wrap.loading-spinner(v-if="item.node.type === 'tw'" v-html="item.node.url")

          template(v-if="item.node.postType === 'expert'")
            .text-center.pt-4
              h6.h4.font-weight-bolder.mt-5(v-if="(type !== 'experts') || (!index && (type === 'experts'))") Expert of the Week
            .card-img-wrap.position-relative.my-4.mx-8(:class="{'mx-md-20': !index}")
              img.rounded-circle(v-if="item.node.featuredImage" :src="item.node.featuredImage.sourceUrl")
            .text-center
              h3.h5.font-weight-bolder.mb-3(v-html="item.node.title")
              p.px-4.mt-3 {{ item.node.position }}
                span.text-primary  @{{ item.node.company }}
              template(v-if="((type === 'all') && item.node.blog) || (!index && item.node.blog)")
                h4.font-weight-bolder.mt-6.px-5.mb-3 {{ item.node.blogTitle }}
                a.btn.btn-primary.text-md.stretched-link.mb-4(:href="item.node.blog") Read more
            .border-top.pt-2(:class="{'pt-sm-5 pb-sm-3': !index}")
              p.text-muted.text-md.px-3.pt-1.pb-3.mb-0.d-flex.align-items-center.justify-content-center.line-height-1-25
                span.icon.icon-sm.flag.mr-2
                  img(svg-inline :src="icon(`flags/${item.node.countryValue}`)")
                | {{ item.node.city ? item.node.city + ',' : '' }} {{ item.node.countryLabel }}
            a.stretched-link(v-if="(type === 'experts') && index && item.node.blog" :href="item.node.blog")

          template(v-if="item.node.postType === 'event'")
            .text-center.date.d-flex.flex-column.justify-content-center.py-5.border-right-0
              p.h1.font-weight-bold.mb-0 {{ days(item.node.start, item.node.end) }}
              p.font-weight-bolder.text-uppercase.text-md {{ months(item.node.start, item.node.end) }}
            .border-top.pt-2.px-5.pt-4
              h3.h4.font-weight-bolder.mb-3(v-html="item.node.title")
              .excerpt.lead-sm.mb-3(v-html="item.node.excerpt")
              p.text-muted
                span.icon.icon-sm.float-left.ml-n1.mr-1
                  img(svg-inline :src="icon('map-pointer')")
                | {{ item.node.location }}
            a.stretched-link(:href="item.node.link")

          template(v-if="item.node.postType === 'project'")
            .pb-3.px-0
              .card-header.position-relative(:style="'background-image: url(' + item.node.cover + ')'")
                .card-overlay.position-absolute.d-flex.flex-column.justify-content-end.px-4
                  h3.h4.font-weight-bolder.mb-3.text-white(v-html="item.node.title")

              .members.text-uppercase.font-weight-bolder.bg-primary.px-4.py-2.text-white.text-sm
              .excerpt.px-4.mt-5(v-html="item.node.excerpt")
              p.text-muted.text-md.px-3.mt-3.mb-0.d-flex.align-items-center
                span.icon.icon-sm.flag.mr-2
                  img(svg-inline :src="icon(`flags/${item.node.countryValue}`)")
                | {{ item.node.city ? item.node.city + ',' : '' }} {{ item.node.countryLabel }}
            a.stretched-link(:href="item.node.link")

      .actions.text-center
        template(v-if="type !== 'all'")
          mugen-scroll(:class="{'loading-spinner': $apollo.loading}" v-if="showMorePages && this[type].pageInfo.hasNextPage" :handler="showMore" :should-handle="!$apollo.loading")
          button.btn.btn-dark.btn-xlg.font-weight-bold(v-if="showMoreEnabled && !showMorePages && this[type].pageInfo.hasNextPage" @click="showMorePages = 2") Show more {{ type }}
        template(v-else)
          a.btn.btn-dark.btn-xlg.font-weight-bold.read-more(v-if="!$apollo.loading" href="#posts" @click="showBlogs()") More news in blog
    template(v-else)
      .text-center
        .loading-spinner


</template>

<script>
import MugenScroll from 'vue-mugen-scroll'

import POSTS_QUERY from '../graphql/posts.gql'
import EVENTS_QUERY from '../graphql/events.gql'
import SOCIALS_QUERY from '../graphql/socials.gql'
import PROJECTS_QUERY from '../graphql/projects.gql'
import EXPERTS_QUERY from '../graphql/experts.gql'

import { addPostType } from './helpers'

const first = 8
const supportedTypes = ['all', 'projects', 'posts', 'events', 'experts']

export default {
  name: 'PostsFeed',
  components: {
    MugenScroll
  },
  data () {
    return {
      showMoreEnabled: true,
      type: 'all',
      showMorePages: 0,
      expertsFirstPage: false,

      posts: null,
      upcomingEvents: null,
      events: null,
      socials: null,
      projects: null,
      experts: null,
      featuredExpert: null,
    }
  },
  apollo: {
    posts: {
      query: POSTS_QUERY,
      variables () {
        return {
          first,
          ...this.type === 'all' ? { notIn: this.experts.edges[0].node.blogId } : {}
        }
      },
      update ({ posts }) {
        return addPostType(posts)
      },
      skip () {
        return !(['posts'].includes(this.type) || ((this.type === 'all') && this.experts))
      }
    },
    upcomingEvents: {
      query: EVENTS_QUERY,
      variables: {
        first,
        pastEvents: false,
        order: 'ASC'
      },
      update ({ events }) {
        return addPostType(events)
      },
      skip () {
        return !['events', 'all'].includes(this.type)
      }
    },
    events: {
      query: EVENTS_QUERY,
      variables: {
        first,
        pastEvents: true,
        order: 'DESC'
      },
      update ({ events }) {
        return addPostType(events)
      },
      skip () {
        return !['events', 'all'].includes(this.type)
      }
    },
    socials: {
      query: SOCIALS_QUERY,
      variables: {
        first
      },
      update ({ socials }) {
        return addPostType(socials)
      },
      skip () {
        return !['socials', 'all'].includes(this.type)
      }
    },
    projects: {
      query: PROJECTS_QUERY,
      variables: {
        first
      },
      update ({ projects }) {
        return addPostType(projects)
      },
      skip () {
        return !['projects'].includes(this.type)
      }
    },
    experts: {
      query: EXPERTS_QUERY,
      variables: {
        first
      },
      update ({ experts }) {
        let posts = addPostType(experts)
        if (!this.expertsFirstPage) {
          const featuredItem = posts.edges.find(item => item.node.featured)
          posts.edges.splice(posts.edges.indexOf(featuredItem), 1)
          posts.edges.unshift(featuredItem)
          this.expertsFirstPage = true
        }
        return posts
      },
      skip () {
        return !['experts', 'all'].includes(this.type)
      }
    }
  },
  computed: {
    all () {
      if (this.$apollo.loading) return { edges: []}
      let edges = []

      if (this.posts && this.posts.edges[0]) edges.push(this.posts.edges[0])
      if (this.experts && this.experts.edges[0]) edges.push(this.experts.edges[0])
      if (this.socials && this.socials.edges[0]) edges.push(this.socials.edges[0])
      if (this.posts && this.posts.edges[1]) edges.push(this.posts.edges[1])
      if (this.upcomingEvents && this.upcomingEvents.edges[0]) edges.push(this.upcomingEvents.edges[0])
      if (this.posts && this.posts.edges[2]) edges.push(this.posts.edges[2])
      if (this.socials && this.socials.edges[1]) edges.push(this.socials.edges[1])
      if (this.posts && this.posts.edges[3]) edges.push(this.posts.edges[3])
      if (this.socials && this.socials.edges[2]) edges.push(this.socials.edges[2])
      if (this.upcomingEvents && this.upcomingEvents.edges[1]) edges.push(this.upcomingEvents.edges[1])

      return  {
        edges
      }
    }
  },
  methods: {
    showMore () {
      if(!this[this.type].pageInfo.hasNextPage) return
      this.$apollo.queries[this.type].fetchMore({
        variables: {
          after: this[this.type].pageInfo.endCursor,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newPosts = fetchMoreResult[this.type].edges
          const hasNextPage = fetchMoreResult[this.type].pageInfo.hasNextPage
          const endCursor = fetchMoreResult[this.type].pageInfo.endCursor

          this.showMoreEnabled = hasNextPage
          this.showMorePages--

          return {
            [this.type]: {
              __typename: previousResult[this.type].__typename,
              edges: [...previousResult[this.type].edges, ...newPosts],
              pageInfo: {
                __typename: previousResult[this.type].pageInfo.__typename,
                hasNextPage,
                endCursor
              }
            }
          }
        }
      })
    },
    renderWidgets () {
      setTimeout(()=>{
        /* eslint-disable */
        FB.init({
          appId            : '2242281849172332',
          autoLogAppEvents : false,
          xfbml            : true,
          version          : 'v3.3'
        })
        FB.Event.subscribe('auth.login', (response) => {
          FB.XFBML.parse()
        })
        FB.Event.subscribe('xfbml.render', () => {
          this.$redrawVueMasonry()
          setTimeout(() => this.$redrawVueMasonry(), 1000)
        })

        twttr.ready((twttr) => {
          twttr.widgets.load()
          twttr.events.bind(
            'rendered',
            (event) => {
              this.$redrawVueMasonry()
              jQuery('.twitter-wrap.loading-spinner').removeClass('loading-spinner')
            }
          )
        })
        /* eslint-enable */
      }, 2000)
    },
    icon (icon) {
      return '/wp-content/themes/solved-theme/resources/assets/icons/' + icon + '.svg'
    },
    days (start, end) {
      return this.$moment(start).format('D') !== this.$moment(end).format('D') ? this.$moment(start).format('D') + '-' + this.$moment(end).format('D') : this.$moment(start).format('D')
    },
    months (start, end) {
      return this.$moment(start).format('MMMM YY') === this.$moment(end).format('MMMM YY') ? this.$moment(start).format('MMMM YY') : this.$moment(start).format('YY') === this.$moment(end).format('YY') ? (this.$moment(start).format('MMMM') + ' - ' + this.$moment(end).format('MMMM YY')) : (this.$moment(start).format('MMMM YY') + ' - ' + this.$moment(end).format('MMMM YY'))
    },
    changeType (value = '') {
      this.showMorePages = 0
      this.showMoreEnabled = true

      if (supportedTypes.includes(value)) {
        window.location.hash = value
        this.type = value
      } else {
        const type = window.location.hash.slice(1)
        if (supportedTypes.includes(type)) this.type = type
      }
    },
    showBlogs () {
      /* eslint-disable */
      jQuery('html, body').animate({
        scrollTop: jQuery('#posts-feed').offset().top - 100,
      }, 1500)
      /* eslint-enable */
    },
    showSections () {
      const hide = supportedTypes.filter((item) => item !== this.type)
      /* eslint-disable */
      hide.forEach((item) => {
        jQuery('.latest-' + item).hide()
      })
      jQuery('.latest-' + this.type).show()
      /* eslint-enable */
    },
    postAuthor (item) {
      return item.node.categories.nodes.find(category => category.name === 'Expert of the Week') ? '' : item.node.author.name
    },
    category (categories) {
      const cats = []
      categories.nodes.forEach(item => item.name !== 'Uncategorized' ? cats.push(item.name): '')
      return cats.join(', ')
    }
  },

  watch: {
    type: {
      handler (value) {
        this.changeType()
        if (value === 'all') this.renderWidgets()
        this.showSections()
      },
      immediate: true
    }
  },

  mounted () {
    window.addEventListener('hashchange', this.changeType)
  },

  destroyed () {
    window.removeEventListener('hashchange', this.changeType)
  }
}
</script>

<style lang="scss" scoped>
.posts-feed {
  .nav-item {
    cursor: pointer;
  }

  .masonry-grid {
    margin: 0 auto;

    .item,
    .grid-sizer {
      width: 350px;
      max-width: 90vw;
    }
    .item {
      margin-bottom: 2rem;

      &.past-event {
        opacity: 0.6;
      }

      @media (min-width: 790px) {
        margin-bottom: 3.75rem;
      }

      .twitter-wrap {
        position: relative;
        margin: -10px 0 !important;
      }

      img {
        width: 100%;
      }

      &.item-0 {
        @media (min-width: 790px) {
          width: 47.5rem;
        }
      }
    }
  }
}
</style>
